module.exports = __webpack_public_path__ + "img/2.ee0b35c6.png";